import React from 'react';
// @mui
import { Stack } from '@mui/material';
import { useSelector } from 'react-redux';

import { NavListRoot } from './NavList';
import _ from 'lodash';

// ----------------------------------------------------------------------

const hideScrollbar = {
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

const NavSectionHorizontal = ({ navConfig, bgcolor = null }) => {
  const { employeePermissions } = useSelector(state => state.app);

  return (
    <Stack direction="row" justifyContent="center" sx={{ bgcolor: bgcolor === null ? 'background.neutral' : bgcolor, borderRadius: 1, px: 0.5 }}>
      <Stack direction="row" sx={{ ...hideScrollbar, py: 1 }}>
        {navConfig.map(group => (
          <Stack key={group.subheader} direction="row" flexShrink={0}>
            {group.items.map(list => {
              if (!_.isNil(list.permission) && employeePermissions.includes(list.permission)) {
                return <NavListRoot key={list.title} list={list} />;
              }
            }
            )}
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default React.memo(NavSectionHorizontal);
